export type DownBarItem = {
  id: DownBarIdType;
  label: string;
  path: string;
  img: JSX.Element;
};

export enum DownBarIdType {
  Watchlist = 'watchlistMenuItem',
  Discover = 'discoverMenuItem',
  MyAccount = 'myAccountMenuItem',
  Funds = 'fundsMenuItem',
  MyProfile = 'myProfile',
  History = 'historyMenuItem',
  Reports = 'reports',
  HelpCenter = 'helpCenterMenuItem',
}
